.Btn {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	user-select: none;
	margin: 0;
	padding: 0;
	width: 100%;
	outline: none;
	border-style: none;
	cursor: pointer;
	pointer-events: inherit;
}
